<template>
  <div class="ml-2">
    <!-- {{dataModel}} -->
    <v-menu
      @change="showTableSelect"
      v-model="menuModel"
      :close-on-content-click="false"
      :close-on-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :class="$vuetify.breakpoint.mdAndUp ? '' : ''"
          :color="color"
          v-on="on"
          small
          text
        >
          <v-icon class="mr-4" small>{{ icon }}</v-icon
          >{{ btnText }}
        </v-btn>
      </template>

      <v-card flat class="pa-4 menu-form" v-if="preset">
        <v-card-title>
          {{ presetTitle }}
        </v-card-title>

        <v-switch
          :label="p.text"
          class="ma-2"
          v-model="table.formModel[p.name]"
          @change="
            // type = p.type;
            // dataModel[p.model] = p.value;
            apply(true, p)
          "
          v-for="(p, i) in preset.filter((p) => {
            return notApplied(p);
          })"
          :key="i"
        >
          <!-- {{ p.text }} -->
        </v-switch>

        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-btn v-if="!controls" text @click="menuModel = 0">Cancel</v-btn>
        </v-toolbar>
      </v-card>
      <v-card v-if="controls && controls.length" flat class="pa-4 menu-form">
        <v-radio-group v-model="type" row mandatory>
          <v-radio label="Add Percent" value="percent"></v-radio>
          <v-radio label="Add Number" value="number"></v-radio>
          <v-radio label="Reset To" value="reset"></v-radio>
        </v-radio-group>
        <v-text-field
          v-for="c in controls"
          :key="c.model"
          :label="c.label"
          type="number"
          v-model="dataModel[c.model]"
        >
        </v-text-field>
        <v-btn text class="ma-2" color="info" @click="applyControls()"
          >Apply To Selected</v-btn
        >
        <v-btn text class="ma-2" color="info" @click="applyControls(true)"
          >Apply To All</v-btn
        >
        <v-btn small @click="close()" text>Cancel</v-btn>
        <!-- <v-text-field label="Min Price" v-model="min_price"> </v-text-field> -->
      </v-card>
    </v-menu>
    <!-- <v-expansion-panels
      :class="$vuetify.breakpoint.smAndDown ? 'mt-n4' : ''"
      flat
    >
      <v-expansion-panel @change="showTableSelect">
        <v-expansion-panel-header> </v-expansion-panel-header>
        <v-expansion-panel-content
          :class="$vuetify.breakpoint.smAndDown ? 'ml-6' : ''"
        >
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels> -->
  </div>
</template>

<script>
import * as fun from "../plugins/common";
export default {
  name: "ChangeRates",
  components: {},
  props: {
    btnText: String,
    icon: String,
    color: String,
    table: Object,
    controls: Array,
    preset: Array,
    presetTitle: String,
    onApplied: String,
    filter: Function,
    parentKey: String,
    parentObjectKey: String,
    save: Boolean,
  },
  data() {
    return {
      dataModel: {},
      percent: 0,
      number: 0,
      type: null,
      tableSelect: false,
      menuModel: 0,
      parObject: null,
    };
  },
  mounted() {
    console.log(this.table);
    if (this.parentObjectKey) {
      var parObject = fun.getParentByProperty(this, "objectKey");
      if (parObject && parObject.objectKey == this.parentObjectKey) {
        this.parObject = parObject;
      }
    }
  },
  beforeDestroy() {},
  methods: {
    showTableSelect() {
      this.tableSelect = !this.tableSelect;
      this.table.select = this.tableSelect;

      this.table.noDelete = this.tableSelect;
      // this.table.noDelete = this.table.singleSelect;
    },
    close() {
      this.table.selected = [];
      this.menuModel = 0;
      this.showTableSelect();
    },
    updateValue(r, k, undo, l) {
      var that = this;
      // var key = k.split(".");
      // var children = false;
      // if (key.length > 1) {
      //   children = true;
      //   // r = r[key[0]];
      //   // k = key[1];
      // }
      var update = function(rec, k, type) {
        var parentKey = "";
        var myKey = k;
        if (k.split(".").length > 1) {
          parentKey = k.split(".")[0];
          myKey = k.split(".")[1];
          rec = rec[parentKey];
          //&& that.parObject
          if (Array.isArray(rec)) {
            var control = that.controls.find((c) => {
              return c.model == k;
            });
            if (control.parFilter) {
              var parObject = that.parObject;
              try {
                rec = rec.find((r) => {
                  return eval(control.parFilter);
                });
              } catch (error) {
                rec = rec[0];
                //
              }

              //r.company_id==parObject.currentCompany
            }
            // var parentObj = fun.getParentByProperty(that, "parentObjectKey");
            // if (
            //   parentObj &&
            //   parentObj.parentObjectKey == that.parentObjectKey
            // ) {
            //   console.log(parentObj);
            // }
            // rec = rec[0];
          }
        }
        // if (parentKey) {
        //   k = k.split(".")[1];
        // }

        var value = fun.getValueFromPath(
          rec,
          myKey.replace(/\[(\d+)\]/g, ".$1")
        );

        var modelValue = that.dataModel[k];
        if (l) {
          modelValue = l.value;
        }
        if (undo) {
          modelValue = -modelValue;
        }

        if (isNaN(value)) {
          value = 0;
        }

        switch (type) {
          case "percent":
            if (undo) {
              value = (100 * value) / (100 - modelValue);
            } else {
              value =
                parseFloat(value) + (parseFloat(value) * modelValue) / 100;
            }

            break;
          case "number":
            value = parseFloat(value) + parseFloat(modelValue);
            break;
          case "reset":
            value = parseFloat(modelValue);
            break;
          default:
            break;
        }

        rec[myKey] = value.toFixed(2);
        fun.updateValueAtPath(
          rec,
          myKey.replace(/\[(\d+)\]/g, ".$1"),
          value.toFixed(2)
        );
      };
      // if (k.split(".").length > 1) {
      //   this.parentKey = k.split(".")[0];
      // }
      // if (this.parentKey) {
      //   // r.forEach((rec) => {
      //   // that.dataModel = that.dataModel[key[0]];
      //   if (this.filter) {
      //     r[this.parentKey]
      //       .filter((b) => {
      //         return this.filter(b);
      //       })
      //       .forEach((a) => {
      //         update(a, k, this.type, r, this.parentKey);
      //       });
      //   }

      //   // });
      //   //
      // } else {
      update(r, k, this.type);
      // }
    },
    notApplied(p) {
      var show = true;
      this.preset.forEach((s) => {
        if (this.table.formModel[s.name] && s.name != p.name) {
          show = false;
        }
      });

      return show;
    },
    applyControls(all) {
      // console.log(this.controls);
      this.controls.forEach((c) => {
        c.type = this.type;
        c.value = this.dataModel[c.model];
        if (c.value) {
          this.apply(all, c);
        }
      });
    },

    apply(all, l) {
      var that = this;
      var records = this.table.table;
      if (!all) {
        records = this.table.selected;
      }
      if (!records.length) {
        this.$root.alertDialog(
          "No Records Selected",
          "Please select some records or click Apply To All"
        );
      }
      var undo = false;
      var key = "";

      if (l && l.key) {
        if (l.name) {
          undo = this.table.formModel[l.name] ? false : true;
        }

        this.type = l.type;
        key = l.key;
        this.dataModel = l.model;
      }

      records.forEach((r) => {
        if (!key) {
          Object.keys(this.dataModel).forEach((k) => {
            that.updateValue(r, k, undo);
          });
        } else {
          if (Array.isArray(r[this.dataModel]) && key) {
            r[this.dataModel].forEach((a) => {
              that.updateValue(a, key, undo, l);
            });
          }
        }
        this.table.update.update.push(r);
      });
      if (this.save) {
        this.table.submit();
      }

      this.table.tableKey = !this.table.tableKey;
      this.menuModel = 0;
      // if (this.onApplied) {
      //   var p = this.table.formModel;
      //   var d = l.name;
      //   eval(this.onApplied);
      // }
      this.$root.$emit("recalculateFields", this);
    },
  },
  watch: {
    menuModel() {
      this.showTableSelect();
    },
  },
  computed: {
    activeDiscounts(p) {
      return this.preset.filter((r) => {
        return this.table.formModel[r.name];
        // if (this.table.formModel[r.name]) {
        //   console.log(r);
        // }
      });
    },
  },
};
</script>

<style lang="css" scoped>
.menu-form {
  background-color: white;
  z-index: 100;
}
</style>
